import s from './mobile.module.scss';
import { ExclamationCircleOutline, CloseOutline } from 'antd-mobile-icons';
import GrtTextArea from '@/components/Mobile/GrtTextArea';
import { Display } from '@/components/Display/Display';
import { useEffect, useState } from 'react';
import { handleSaveFeedBack } from '@/api/grt/feedback';
import { closeMobileFeedModal } from '@/utils/Page/feedback';
import GrtButton from '@/components/Mobile/GrtButton';
import Toast from '@/components/Toast';
import ToastUtils from '@/utils/ToastUtils';
const MobileFeedBack = (props) => {
    const { data, checkIsLogin } = props;
    const [loading, setLoading] = useState(false);
    const [err, setError] = useState({
        question_content: false,
        answer_content: false
    });
    const [formData, setFormData] = useState({
        question_content: '',
        answer_content: '',
        interest_content: '',
        supplement_describe: ''
    });
    const onChange = (value, key) => {
        setFormData({
            ...formData,
            [key]: value
        });
    };

    const onConfirm = async () => {
        let canSave = true;
        let errObj = {};
        let keys = ['question_content', 'answer_content'];
        keys.forEach((key) => {
            let value = formData[key];
            if (value.trim().length === 0) {
                canSave = false;
                errObj[key] = true;
            } else {
                errObj[key] = false;
            }
        });
        setError(errObj);
        if (canSave) {
            let isLogin = await checkIsLogin(false);
            let params = {
                agent_id: data.agent_id,
                session_id: data.session_id,
                anonymous: isLogin ? 0 : 1,
                user_id: data.user_id,
                question_content: formData.question_content,
                answer_content: formData.answer_content,
                interest_content: formData.interest_content,
                supplement_describe: formData.supplement_describe,
                message_user_id: data?._id,
                message_user_id: data.reply_id
            };
            setLoading(true);
            let res = await handleSaveFeedBack(params).finally(() => {
                setLoading(false);
            });
            if (res && res.success) {
                ToastUtils.showToast('操作成功');
                oncloseModal();
            } else {
                ToastUtils.showToast(res.msg || '操作失败');
            }
        }
    };
    useEffect(() => {
        let question_content = data?.originQuestion || data?.question || '';
        setFormData({
            question_content: question_content.substring(0, 100),
            answer_content: '',
            interest_content: '',
            supplement_describe: ''
        });
    }, [data]);
    const oncloseModal = () => {
        setError({
            question_content: false,
            answer_content: false
        });
        closeMobileFeedModal();
    };
    return (
        <>
            <div className={s['box-wrap']}>
                <div className={s['header']}>
                    <span>用户反馈</span>
                    <span onClick={oncloseModal}>
                        <CloseOutline />
                    </span>
                </div>
                <div className={s['content-box']}>
                    <div className={s['group-title']}>针对本次回答</div>
                    <div className={s['feed-back-item']}>
                        <div className={s['title']} style={{ marginTop: 12 }}>
                            <span data-required={true} className={s['title-span']}>
                                原始问题
                            </span>
                            <Display show={err.question_content}>
                                <span className={s['error']}>
                                    <ExclamationCircleOutline />
                                    请输入原始问题
                                </span>
                            </Display>
                        </div>
                        <div className={s['form-wrap']}>
                            <GrtTextArea
                                onChange={(value) => {
                                    onChange(value, 'question_content');
                                }}
                                value={formData.question_content}
                                showCount
                                maxLength={100}
                                placeholder="请输入"
                                rows={2}
                            />
                        </div>
                    </div>
                    <div className={s['feed-back-item']}>
                        <div className={s['title']}>
                            <span data-required={true} className={s['title-span']}>
                                您认为正确的答案
                            </span>
                            <Display show={err.answer_content}>
                                <span className={s['error']}>
                                    <ExclamationCircleOutline />
                                    请输入您认为正确的答案
                                </span>
                            </Display>
                        </div>
                        <div className={s['form-wrap']}>
                            <GrtTextArea
                                onChange={(value) => {
                                    onChange(value, 'answer_content');
                                }}
                                value={formData.answer_content}
                                showCount
                                maxLength={500}
                                placeholder="请输入"
                                rows={2}
                            />
                        </div>
                    </div>
                    <div className={s['group-title']}>其他反馈</div>
                    <div className={s['feed-back-item']}>
                        <div className={s['title']}>
                            <span className={s['title-span']}>您感兴趣的问题</span>
                        </div>
                        <div className={s['form-wrap']}>
                            <GrtTextArea
                                onChange={(value) => {
                                    onChange(value, 'interest_content');
                                }}
                                value={formData.interest_content}
                                showCount
                                maxLength={500}
                                placeholder="请输入"
                                rows={2}
                            />
                        </div>
                    </div>
                    <div className={s['feed-back-item']}>
                        <div className={s['title']}>
                            <span className={s['title-span']}>补充说明</span>
                        </div>

                        <div className={s['form-wrap']}>
                            <GrtTextArea
                                onChange={(value) => {
                                    onChange(value, 'supplement_describe');
                                }}
                                value={formData.supplement_describe}
                                showCount
                                maxLength={100}
                                placeholder="请输入"
                                rows={2}
                            />
                        </div>
                    </div>
                </div>
                <div className={s['action-wrap']}>
                    <GrtButton className={s['cancel']} color="default" onClick={oncloseModal}>
                        取消
                    </GrtButton>
                    <GrtButton loading={loading} className={s['confirm']} color="primary" onClick={onConfirm}>
                        确定
                    </GrtButton>
                    {/* <span className={s['cancel']} onClick={oncloseModal}>
                        取消
                    </span>
                    <span className={s['confirm']} onClick={onConfirm}>
                        确定
                    </span> */}
                </div>
            </div>
        </>
    );
};

export default MobileFeedBack;
